import AxiosInstance from "./api";

export const GeneralLedgerMultiColumnVouchersService = {
  getAccounts: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/general-ledger-multi-column-vouchers/accounts", {
      params: query,
    });
  },

  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/general-ledger-multi-column-vouchers", {
      params: query,
    });
  },
};
